import Vue from 'vue'
import Router from 'vue-router'
//index page
import demo from '../pages/demo.vue'
import login from '../pages/login.vue'
import logout from '../pages/logout.vue'
import error from '../pages/error.vue'
//user
import setting from '../pages/user/setting.vue'
import msgList from '../pages/user/msgList.vue'
import deviceList from '../pages/user/deviceList.vue'
// tempControl
// const tempControlIndex =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/index.vue')
// // const realData =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/realData.vue')
// const historyData =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/historyData.vue')
// const standardSet =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/standardSet.vue')
// const controlSet =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/controlSet.vue')
// const deviceConf =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/deviceConf.vue')
// const autoVal =()=> import (/* webpackChunkName: "tempControl" */ './../pages/tempControl/autoVal.vue')
// const b = resolve => require(['./components/b.vue'], resolve)
// const realData = resolve => require(['./../pages/tempControl/realData.vue'], resolve)


import tempControlIndex from '../pages/tempControl/index.vue'
import TrealData from '../pages/tempControl/realData.vue'
import ThistoryData from '../pages/tempControl/historyData.vue'
import TstandardSet from '../pages/tempControl/standardSet.vue'
import TcontrolSet from '../pages/tempControl/controlSet.vue'
import TdeviceConf from '../pages/tempControl/deviceConf.vue'
import TautoVal from '../pages/tempControl/autoVal.vue'

import MtempControlIndex from '../pages/mobileTemp/index.vue'
import MTrealData from '../pages/mobileTemp/realData.vue'
import MThistoryData from '../pages/mobileTemp/historyData.vue'
import MTstandardSet from '../pages/mobileTemp/standardSet.vue'
import MTcontrolSet from '../pages/mobileTemp/controlSet.vue'
import MTdeviceConf from '../pages/mobileTemp/deviceConf.vue'
import MTautoVal from '../pages/mobileTemp/autoVal.vue'

import WrealData from '../pages/allocateWater/realData.vue'
import Windex from '../pages/allocateWater/index.vue'
import WcontrolConf from '../pages/allocateWater/controlConf.vue'
import WstandConf from '../pages/allocateWater/standConf.vue'
import WoutputData from '../pages/allocateWater/outputData.vue'
import WdeviceConf from '../pages/allocateWater/deviceConf.vue'
import WautoVal from '../pages/allocateWater/autoVal.vue'
import chartsPlayer from '../components/tempControl/chartsPlayer.vue'



Vue.use(Router);

export default new Router({
    mode:"history",
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '',
            redirect: '/login'
        },
        {
            path: '/login',
            name: '登陆',
            component: login
        },
        {
            path:'/error',
            name:'错误啦',
            component:error
        },
        {
            path:'/chartsPlayer',
            name:'播放',
            component:chartsPlayer

        },
        {
            path: '/tempControl/',
            component: tempControlIndex,
            children: [
                {
                    path: '',
                    redirect: '/tempControl/realData'
                },
                {
                    path: 'realData',
                    name: '工艺曲线',
                    component: TrealData
                }, {
                    path: 'historyData',
                    name: '产量报表',
                    component: ThistoryData
                },
                {
                    path: 'standardSet',
                    name: '标准参数',
                    component: TstandardSet
                },
                {
                    path: 'controlSet',
                    name: '控制参数',
                    component: TcontrolSet
                },{
                    path: 'autoVal',
                    name: '控制变量',
                    component: TautoVal
                },
                 {
                    path: 'deviceConf',
                    name: '设备配置',
                    component: TdeviceConf
                },
            ]
        },  {
            path: '/MtempControl/',
            component: MtempControlIndex,
            children: [
                {
                    path: '',
                    redirect: '/MtempControl/realData'
                },
                {
                    path: 'realData',
                    name: '工艺曲线',
                    component: MTrealData
                }, {
                    path: 'historyData',
                    name: '产量报表',
                    component: MThistoryData
                },
                {
                    path: 'standardSet',
                    name: '标准参数',
                    component: MTstandardSet
                },
                {
                    path: 'controlSet',
                    name: '控制参数',
                    component: MTcontrolSet
                },{
                    path: 'autoVal',
                    name: '控制变量',
                    component: MTautoVal
                },
                 {
                    path: 'deviceConf',
                    name: '设备配置',
                    component: MTdeviceConf
                },
            ]
        },   {
            path: '/allocate/',
            component: Windex,
            children: [
                { path: '', redirect: 'realData' },
                { path: 'realData',name:'实时数据', component:WrealData },
                { path: 'outputData',name:'统计数据', component:WoutputData },
                { path: 'standConf',name:'标准参数', component:WstandConf },
                { path: 'controlConf',name:'控制参数', component:WcontrolConf },
                {
                    path: 'autoVal',
                    name: '控制变量',
                    component: WautoVal
                },
                 {
                    path: 'deviceConf',
                    name: '设备配置',
                    component: WdeviceConf
                },

            ]
        },
        {
            path: '/user/',
            component: tempControlIndex,
            children: [
                { path: '', redirect: 'deviceList' },
                { path: 'setting', name: '账户设置', component: setting },
                { path: 'msgList', name: '消息列表', component: msgList },
                { path: 'deviceList', name: '设备列表', component: deviceList },

            ]
        },
        {
            path: '/demo/',
            name: 'demo',
            component: demo
        },
        {
            path: '/logout',
            name: 'logout',
            component: logout
        },
        {
            path: '*',
            name: 'error',
            component: error
        },




    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js